export enum GROUP_TYPES {
  S1 = 'S1',
  V2 = 'V2',
  DESCONTOS_FINANCEIROS = 'DESCONTOS_FINANCEIROS',
}
